/*
  Project: Michels Legal
  Author: Luum GmbH
 */
import '../../node_modules/foundation-sites/dist/js/foundation';
import main from './modules/main';
import news from './modules/news';
import videoSlider from './modules/video-slider';

main();
news();
videoSlider();



// WEBPACK FOOTER //
// ./src/scripts/app.js